import React from 'react';
import { FeeBreakdownV2 } from '@/types/payments';
import { FEE_BREAKDOWN_V2_STRUCTURE } from '../constants/transactionConstants';
import { formatCurrency } from '@/lib';

interface FeeBreakdownV2TooltipProps {
    feeBreakdownV2: FeeBreakdownV2;
    paymentMethodType: string;
}

export const FeeBreakdownV2Tooltip: React.FC<FeeBreakdownV2TooltipProps> = ({ feeBreakdownV2, paymentMethodType }) => {
    return (
        <div className='flex flex-col items-start p-1 text-left'>
            <div className='text-xs font-bold'>{paymentMethodType} Fee Breakdown</div>

            {FEE_BREAKDOWN_V2_STRUCTURE.map(fee => {
                const feeData = feeBreakdownV2[fee.key];
                if (!feeData) return null;

                return (
                    <div key={fee.key} className='mt-2 text-xs font-normal'>
                        Stripe&apos;s {fee.name}:{' '}
                        <span className='font-bold'>
                            {formatCurrency(feeData.value ?? 0, feeData.currency ?? 'USD')}
                        </span>
                    </div>
                );
            })}

            <div className='mt-2 text-xs font-normal italic'>
                Learn more about Stripe&apos;s fees{' '}
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 underline'
                    href='https://help.stan.store/article/83-stan-stripes-transaction-fees'
                >
                    here
                </a>
                .
            </div>
        </div>
    );
};
